import { render, staticRenderFns } from "./AddUserTicketDialog.vue?vue&type=template&id=48b299a2"
import script from "./AddUserTicketDialog.js?vue&type=script&lang=js&external"
export * from "./AddUserTicketDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports